export default __webpack_public_path__ + "static/media/face_shot_cropped.02c31c11.jpg";